module.exports = __webpack_public_path__ + "static/media/kollased_jooned.ea9f6152.svg";